// Точка входа SPA: стили, подключение функций (features), запуск интерфейса.
import { createRoot } from 'react-dom/client';
import './styles/ui.css';
import './styles/page.css';
import { registry } from './core/registry';
import { FEATURES } from './features';
import { App } from './ui/App';
import { AuthRoot } from './features/auth/AuthRoot';
import { startAuth } from './features/auth/session';

for (const setup of FEATURES) {
  try { setup(registry); } catch (e) { console.error('Ошибка подключения функции', e); }
}

// для отладки и автотестов (Playwright): window.sto.editor, window.sto.store … - появляется после входа
import { appStore } from './core/store';
import { ctx, runCommand } from './core/ctx';
import { numberingStore } from './core/editor/numberingPlugin';
import { authStore, checkSession } from './features/auth/session';
const expose = () => {
  (window as any).sto = { registry, store: appStore, ctx, run: runCommand, numbering: numberingStore,
    auth: Object.assign({}, authStore, { check: checkSession }), get editor() { return appStore.getState().editor; } };
};

// вход: страница уже с токеном сессии - сразу приложение; иначе экраны входа / регистрации / первого запуска
void startAuth(expose);
createRoot(document.getElementById('root')!).render(<AuthRoot><App /></AuthRoot>);
